import {
  VERIFICATION_COMPLETE_BEGIN,
  VERIFICATION_COMPLETE_SUCCESS,
  VERIFICATION_COMPLETE_FAILURE,
  VERIFICATION_REJECT_BEGIN,
  VERIFICATION_REJECT_SUCCESS,
  VERIFICATION_REJECT_FAILURE,
  FETCH_VERIFICATION_DATES_BEGIN,
  FETCH_VERIFICATION_DATES_SUCCESS,
  FETCH_VERIFICATION_DATES_FAILURE,
  FETCH_DISCIPLINESBY_JOBID_BEGIN,
  FETCH_DISCIPLINESBY_JOBID_SUCCESS,
  FETCH_DISCIPLINESBY_JOBID_FAILURE,
  FETCH_VERIFICATION_ANNOTATION_BEGIN,
  FETCH_VERIFICATION_ANNOTATION_SUCCESS,
  FETCH_VERIFICATION_ANNOTATION_FAILURE,
  FETCH_VERIFICATION_ANNOTATION_STATS_BEGIN,
  FETCH_VERIFICATION_ANNOTATION_STATS_SUCCESS,
  FETCH_VERIFICATION_ANNOTATION_STATS_FAILURE,
  FETCH_SEARCH_RESULTS_BEGIN,
  FETCH_SEARCH_RESULTS_SUCCESS,
  FETCH_SEARCH_RESULTS_FAILURE,
  FETCH_AUTOPOPULATE_RESULTS_BEGIN,
  FETCH_AUTOPOPULATE_RESULTS_SUCCESS,
  FETCH_AUTOPOPULATE_RESULTS_FAILURE,
  RESET_FEEDBACK,
  FETCH_FEEDBACK_SUCCESS,
  FETCH_VERIFICATION_ANNOTATION_NODATA,
  UPDATE_ANNOTATIONS_DISCARD_RESTORE,
  UPDATE_ANNOTATIONS_READ_MESSAGE,
  GET_RECONCILIATION_REPORT_STARTED,
  GET_RECONCILIATION_REPORT_SUCCESS,
  GET_RECONCILIATION_REPORT_FAILURE,
  STAMP_ENDORSEMENT_STARTED,
  STAMP_ENDORSEMENT_SUCCESS,
  STAMP_ENDORSEMENT_FAILURE,
  GET_COMMENT_REPO_DISCIPLINES_SUCCESS,
  GET_INITIAL_COMMENTS_SUCCESS,
  GET_INITIAL_COMMENTS_FAILURE,
  GET_ADDITIONAL_DOCUMENT_SUCCESS,
  GET_MORE_COMMENTS_SUCCESS,
  GET_SUGGESTIONS_SUCCESS,
  CLEAR_COMMENT_LETTER,
  GET_COMMENT_LETTER,
  GET_COMMENT_LETTER_FAILURE,
  GET_COMMENT_LETTER_SUCCESS,
  UPDATE_ANNOTATIONDATA_NEEDSINPUT,
  UPDATE_FAVOURITE_ANNOTATIONS,
} from "@safecv/actions/types";

const initialState = {
  disciplines: [],
  annotationPayload: [],
  autopopulateResults: [],
  searchResults: null,
  feedback: [],
  planName: "",
  reasonForRejection: "",
  planStatus: "",
  createdDate: "",
  annotatedDate: "",
  verifiedDate: "",
  reasonForFailure: "",
  description: "",
  spinnerLoading: false,
  verificationStatusLoading: false,
  pdfBlob: null,
  pdfDownloadStatus: false,
  noData: false,
  discardedData: [],
  preference: null,
  reconciliationReport: null,
  reconciliationReportLoading: false,
  commentLetterLoading: false,
  stampendorsementLoading: false,
  initialComments: null,
  allComments: [],
  myComments: [],
  topComments: [],
  showMoreAllComments: false,
  showMoreMyComments: false,
  additionalDocs: null,
  sugesstions: [],
  commentletter: "",
  id: null,
  favouriteAnnotations: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case VERIFICATION_COMPLETE_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
      };
    case VERIFICATION_COMPLETE_SUCCESS:
      return {
        ...state,
        spinnerLoading: false,
      };
    case VERIFICATION_COMPLETE_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
      };
    case VERIFICATION_REJECT_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
      };
    case VERIFICATION_REJECT_SUCCESS:
      return {
        ...state,
        spinnerLoading: false,
      };
    case VERIFICATION_REJECT_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
      };
    case FETCH_DISCIPLINESBY_JOBID_BEGIN:
      return {
        ...state,
        // spinnerLoading: true,
      };
    case FETCH_DISCIPLINESBY_JOBID_SUCCESS:
      return {
        ...state,
        disciplines: action.payload.disciplines,
        // spinnerLoading: false,
      };
    case FETCH_DISCIPLINESBY_JOBID_FAILURE:
      return {
        ...state,
        // spinnerLoading: false,
      };
    case FETCH_VERIFICATION_DATES_BEGIN:
      return {
        ...state,
        verificationStatusLoading: true,
      };
    case FETCH_VERIFICATION_DATES_SUCCESS:
      return {
        ...state,
        planName: action.payload.planName,
        reasonForRejection: action.payload.reasonForRejection,
        planStatus: action.payload.planStatus,
        verifiedDate: action.payload.verifiedDate,
        annotatedDate: action.payload.annotatedDate,
        createdDate: action.payload.createdDate,
        dueDate: action.payload.dueDate,
        codebookName: action.payload.codebookName,
        reasonForFailure: action.payload.reasonForFailure,
        description: action.payload.description,
        prReasonForFailure: action.payload.prReasonForFailure,
        prStatus: action.payload.prStatus,
        verificationStatusLoading: false,
        preference: action.payload.preference,
      };
    case FETCH_VERIFICATION_DATES_FAILURE:
      return {
        ...state,
        verificationStatusLoading: false,
      };
    case FETCH_VERIFICATION_ANNOTATION_BEGIN:
      return {
        ...state,
        noData: false,
        spinnerLoading: true,
        autopopulateResults: [],
        annotationPayload: [],
      };
    case FETCH_VERIFICATION_ANNOTATION_NODATA:
      return {
        ...state,
        annotationPayload: [],
        spinnerLoading: false,
        noData: true,
      };
    case FETCH_VERIFICATION_ANNOTATION_SUCCESS:
      return {
        ...state,
        annotationPayload: action.payload.annotationPayload,
        favouriteAnnotations: action.payload.annotationPayload
          .filter((annot) => annot.isFavourite)
          .map((annot) => annot.annotationName),
        spinnerLoading: false,
        noData: false,
      };
    case FETCH_VERIFICATION_ANNOTATION_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
      };

    case FETCH_VERIFICATION_ANNOTATION_STATS_BEGIN:
      return {
        ...state,
      };
    case FETCH_VERIFICATION_ANNOTATION_STATS_SUCCESS:
      return {
        ...state,
        annotationStats: action.payload,
      };
    case FETCH_VERIFICATION_ANNOTATION_STATS_FAILURE:
      return {
        ...state,
      };

    case FETCH_SEARCH_RESULTS_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
        searchResults: null,
      };

    case FETCH_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        spinnerLoading: false,
        searchResults: action.payload.searchResults,
      };

    case FETCH_SEARCH_RESULTS_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
        searchResults: null,
      };

    case FETCH_AUTOPOPULATE_RESULTS_BEGIN:
      return {
        ...state,
        // spinnerLoading: true,
      };

    case FETCH_AUTOPOPULATE_RESULTS_SUCCESS:
      return {
        ...state,
        // spinnerLoading: false,
        autopopulateResults: action.payload.autopopulateResults,
      };

    case FETCH_AUTOPOPULATE_RESULTS_FAILURE:
      return {
        ...state,
        autopopulateResults: [],
        // spinnerLoading: false,
      };

    case RESET_FEEDBACK:
      return {
        ...state,
        feedback: [],
      };
    case FETCH_FEEDBACK_SUCCESS:
      return {
        ...state,
        feedback: action.payload.messages,
      };
    case UPDATE_ANNOTATIONS_DISCARD_RESTORE:
      let annotationData = [...state.annotationPayload];
      const index = annotationData.findIndex(
        (annotation) => annotation.id === action.payload.annotationId
      );
      annotationData[index].discarded = action.payload.isDiscarded;
      annotationData[index].notes = action.payload.reasonForDiscard;
      return {
        ...state,
        annotationPayload: annotationData,
      };
    case UPDATE_ANNOTATIONS_READ_MESSAGE:
      let annotationReadData = [...state.annotationPayload];
      let readIndex = annotationReadData.findIndex(
        (annotation) => annotation.id === action.payload.annotationId
      );
      annotationReadData[readIndex].read = action.payload.value;
      return {
        ...state,
        annotationPayload: annotationReadData,
      };
    case GET_RECONCILIATION_REPORT_STARTED:
      return {
        ...state,
        reconciliationReportLoading: true,
      };
    case GET_RECONCILIATION_REPORT_SUCCESS:
      return {
        ...state,
        reconciliationReportLoading: false,
        reconciliationReport: action.payload.reconciliationReport,
      };
    case GET_RECONCILIATION_REPORT_FAILURE:
      return {
        ...state,
        reconciliationReportLoading: false,
      };

    case GET_COMMENT_LETTER:
      return {
        ...state,
        commentLetterLoading: true,
      };
    case GET_COMMENT_LETTER_SUCCESS:
      return {
        ...state,
        commentLetterLoading: false,
        commentLetter: action.payload.commentLetter,
        id: action.payload.id,
      };
    case GET_COMMENT_LETTER_FAILURE:
      return {
        ...state,
        commentLetterLoading: false,
      };
    case STAMP_ENDORSEMENT_STARTED:
      return {
        ...state,
        stampendorsementLoading: true,
      };
    case STAMP_ENDORSEMENT_SUCCESS:
      return {
        ...state,
        stampendorsementLoading: false,
      };
    case STAMP_ENDORSEMENT_FAILURE:
      return {
        ...state,
        stampendorsementLoading: false,
      };
    case GET_COMMENT_REPO_DISCIPLINES_SUCCESS: {
      return {
        ...state,
        disciplines: action.payload,
      };
    }

    case GET_INITIAL_COMMENTS_SUCCESS: {
      return {
        ...state,
        initialComments: action.payload,
        allComments: action.payload.data.allComments,
        myComments: action.payload.data.myComments,
        topComments: action.payload.data.topComments,
        showMoreAllComments: action.payload.data.showMoreAllComments,
        showMoreMyComments: action.payload.data.showMoreMyComments,
      };
    }

    case GET_INITIAL_COMMENTS_FAILURE: {
      return {
        ...state,
        initialComments: null,
        allComments: [],
        myComments: [],
        topComments: [],
        showMoreAllComments: false,
        showMoreMyComments: false,
      };
    }

    case GET_ADDITIONAL_DOCUMENT_SUCCESS:
      return {
        ...state,
        additionalDocs: action.payload,
        // spinnerLoading: false,
      };

    case GET_MORE_COMMENTS_SUCCESS: {
      if (action.section === "mycomments") {
        return {
          ...state,
          myComments: [...state.myComments, ...action.payload.comments],
          showMoreMyComments: action.payload.showmore,
        };
      } else if (action.section === "allcomments") {
        return {
          ...state,
          allComments: [...state.allComments, ...action.payload.comments],
          showMoreAllComments: action.payload.showmore,
        };
      } else {
        return state;
      }
    }
    case GET_SUGGESTIONS_SUCCESS:
      if (action.payload.length === 0) {
        return {
          ...state,
          sugesstions: state.suggesstions,
        };
      } else {
        return {
          ...state,
          sugesstions: action.payload[0].comment,
        };
      }
    case CLEAR_COMMENT_LETTER:
      return {
        ...state,
        commentLetter: "",
        id: null,
      };

    case UPDATE_ANNOTATIONDATA_NEEDSINPUT:
      let annotations = state.annotationPayload;
      let response = action.payload.userResponse;
      let annotationId = action.payload.annotationId;
      let selectedAnnotation = annotations.find(
        (annotation) => annotation.id === annotationId
      );
      selectedAnnotation.needsInput.forEach((question) => {
        if (response[question.id]) {
          question.response = response[question.id];
        }
      });
      return {
        ...state,
        annotationPayload: annotations,
      };

    case UPDATE_FAVOURITE_ANNOTATIONS:
      return {
        ...state,
        favouriteAnnotations: action.payload.favData.map(
          (annot) => annot.annotationName
        ),
      };

    default:
      return state;
  }
}
